import React from "react";
import { Modal, Button } from "react-bootstrap";
import FontAwesome from "react-fontawesome";

export default function({ show, close, data, remove }) {
  return (
    <Modal show={ show } onHide={ close }>

      <Modal.Header closeButton>
        <Modal.Title>Field Preview</Modal.Title>
      </Modal.Header>

      <Modal.Body>

        <div className="align-center">
          <h3>{ data.label }{ !data.mandatory ? <small className="gray"> (optional)</small> : null}</h3>
          <FontAwesome name="camera" size="4x" />
          <p>Choose a document</p>
        </div>

      </Modal.Body>

      <Modal.Footer>
        <Button onClick={ close }>Cancel</Button>
        <Button onClick={ remove } bsStyle="warning">Delete</Button>
      </Modal.Footer>

    </Modal>
  )
}



// WEBPACK FOOTER //
// ./src/components/Settings/Customers/PreviewCustomerDocument.js